module.exports = __webpack_public_path__ + "img/banner_Garment.334cb959.jpg";